import { parseDotenvFile } from '@cli-utils/files.js'

/** The Vercel Neon integration emits the standard `DATABASE_URL` plus a pooled `POSTGRES_URL`. */
export function readDbUrlFromDotenv(filePath: string): string | undefined {
  const vars = parseDotenvFile(filePath)

  const isPg = (v: string | undefined): v is string =>
    !!v && (v.startsWith('postgres://') || v.startsWith('postgresql://'))

  if (isPg(vars.get('DATABASE_URL'))) return vars.get('DATABASE_URL')
  if (isPg(vars.get('POSTGRES_URL'))) return vars.get('POSTGRES_URL')
  return undefined
}
